const root = document.querySelector("[data-nanzora-entrance]");

if (root) {
  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const seen = sessionStorage.getItem("nanzora_entrance_seen") === "1";
  const enterButton = root.querySelector("[data-nanzora-enter]");
  const skipButton = root.querySelector("[data-nanzora-skip]");
  const status = root.querySelector("[data-nanzora-entrance-status]");
  const focusables = [enterButton, skipButton].filter(Boolean);
  let sceneController = null;
  let openingRequested = false;
  let closing = false;
  let backgroundInert = false;

  const setBackgroundInert = (enabled) => {
    if (enabled === backgroundInert) return;
    backgroundInert = enabled;

    let node = root;
    while (node && node !== document.body) {
      const parent = node.parentElement;
      if (!parent) break;
      for (const sibling of parent.children) {
        if (sibling === node) continue;
        if (enabled) sibling.setAttribute("inert", "");
        else sibling.removeAttribute("inert");
      }
      node = parent;
    }
  };

  const beginOpening = () => {
    root.classList.add("is-opening");
    root.setAttribute("aria-busy", "true");
    if (enterButton) enterButton.disabled = true;
    if (status) status.textContent = "The doors are opening.";
  };

  const closeEntrance = () => {
    if (closing) return;

    closing = true;
    sessionStorage.setItem("nanzora_entrance_seen", "1");
    root.classList.add("is-leaving");
    root.setAttribute("aria-busy", "false");
    setBackgroundInert(false);
    window.nanzoraEmit?.("entrance_complete");
    window.setTimeout(
      () => {
        sceneController?.dispose();
        root.hidden = true;
        document.body.style.removeProperty("overflow");
        document
          .querySelector(".nanzora-hero h1")
          ?.focus?.({ preventScroll: true });
      },
      reducedMotion ? 10 : 680,
    );
  };

  const openDoors = () => {
    if (openingRequested || closing) return;

    openingRequested = true;

    if (reducedMotion || root.classList.contains("is-fallback")) {
      beginOpening();
      closeEntrance();
      return;
    }

    if (sceneController) {
      beginOpening();
      sceneController.open();
      return;
    }

    // Scene is still loading: keep Skip usable until WebGL is ready or fails.
    if (enterButton) enterButton.disabled = true;
    if (status) status.textContent = "Preparing the doors.";
  };

  const trapFocus = (event) => {
    if (event.key !== "Tab" || focusables.length < 2 || closing) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  };

  if (seen) {
    root.hidden = true;
  } else {
    document.body.style.overflow = "hidden";
    setBackgroundInert(true);
    enterButton?.addEventListener("click", openDoors);
    skipButton?.addEventListener("click", closeEntrance);
    root.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeEntrance();
      trapFocus(event);
    });
    window.requestAnimationFrame(() =>
      enterButton?.focus({ preventScroll: true }),
    );

    if (!reducedMotion) {
      import("./experience/door-scene.js")
        .then(async ({ createDoorScene }) => {
          sceneController = await createDoorScene(
            root.querySelector("canvas"),
            closeEntrance,
          );
          if (closing) {
            sceneController.dispose();
            return;
          }
          root.classList.add("is-webgl", "is-ready");
          if (openingRequested) {
            beginOpening();
            sceneController.open();
          }
        })
        .catch(() => {
          root.classList.add("is-fallback", "is-ready");
          if (openingRequested) {
            beginOpening();
            closeEntrance();
          }
        });
    } else {
      root.classList.add("is-fallback", "is-ready");
    }
  }
}
